socialNetworksUrl = (name) ->
  ((key, value) ->
    if arguments.length > 1
      if not @get('organization.social_networks')?
        @set('organization.social_networks', {})
      value = value.trim()

      if value.length == 0
        delete @get('organization.social_networks')[name]
      else
        @get('organization.social_networks')[name] = value

      @notifyPropertyChange('organization.social_networks')

    @get('organization.social_networks')?[name]
  ).property('organization.social_networks')

App.SettingsOrganizationController = Em.Controller.extend
  inappSupport: Em.inject.service('inappSupport')

  organizationBinding: 'model'

  vkUrl:        socialNetworksUrl('vk')
  instagramUrl: socialNetworksUrl('instagram')
  facebookUrl:  socialNetworksUrl('facebook')
  twitterUrl:   socialNetworksUrl('twitter')
  telegramUrl:  socialNetworksUrl('telegram')

  isSaving: false
  fileInput: null
  fileIsUploading: false

  fileFaviconInput: null
  fileFaviconIsUploading: false

  timezones: TIMEZONES

  ## timezone - вычислимое поле, всегда содержит значение
  ## timezone_own переопределенную зону для конкретной организации
  hasDefaultTimezone: Em.computed(
    'organization.timezone',
    'organization.timezone_own', ->
      !@get('organization.timezone_own')
  )

  timezone: Em.computed [
    'organization.timezone',
    'organization.timezone_own'
    'hasDefaultTimezone'
  ]..., ->
    if @get('hasDefaultTimezone')
      @get('organization.timezone')
    else
      @get('organization.timezone_own')

  imageStyle: Em.computed(
    'organization.logo_medium_url'
    ->
      logo = @get('organization.logo_medium_url')

      if logo?
        return "background-color: grey; background-image: url(#{ logo })".htmlSafe()
      else
        return "background-image: url(#{ @get('organization.avatarPlaceholder') })".htmlSafe()
  )

  imageFaviconStyle: Em.computed(
    'organization.favicon'
    ->
      favicon = @get('organization.favicon')

      if favicon?
        return "background-color: grey; background-image: url(#{ favicon })".htmlSafe()
      else
        return "background-image: url(#{ @get('organization.avatarPlaceholder') })".htmlSafe()
  )

  actions:
    changeTimezone: (timezone) ->
      @set 'organization.timezone_own', timezone
      false

    saveOrganization: ->
      @set('isSaving', true)

      @get('organization').save()
      .finally =>
        @set('isSaving', false)

    discartChanges: ->
      @get('organization').rollback()

    askSupport: ->
      @get('inappSupport')?.initiateDialogue()
      false

    openFileDialog: ->
      @get('fileInput').send('openDialog')
      false

    uploadPhoto: (file) ->
      @set('fileIsUploading', true)
      organization = @get('organization')

      organization.uploadLogo(file)
        .then ->
          organization.reload()
        .finally =>
          @set('fileIsUploading', false)

      false

    openFaviconFileDialog: ->
      @get('fileFaviconInput').send('openDialog')
      false

    uploadFavicon: (file) ->
      @set('fileFaviconIsUploading', true)
      organization = @get('organization')

      organization.uploadFavicon(file)
        .then ->
          organization.reload()
        .finally =>
          @set('fileFaviconIsUploading', false)

      false
